import { deleteApi, getApi, postApi, putApi } from "./http.service";

export const createNewDistributor=async(payload:any)=>{
    return postApi('distributor',payload);
}

export const getDistributorById=async(id:any)=>{
    return getApi('distributor/'+id);
}

export const updateDistributorById=async(id:any, payload:any)=>{
    return putApi('distributor/'+id, payload);
}

export const deleteDistributorById=async(id:any)=>{
    return deleteApi('distributor/'+id);
}